  $(document).ready(function() {
    $(".faq h4").each(function(){
      $(this).next().hide();
    });
    $(".faq h4").click(function() {
         
      $(this).next().slideToggle();
      $(this).toggleClass("active");
    });


    
  });